'use client'

import { StatsigUser } from '@statsig/react-bindings'

import { getQueryParam } from '@src/quince-site-common/src/utils/get-query-param'
import { getlbUserId } from '@src/quince-site-common/src/utils/getlb-user-id'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'

import { STATSIG_EXPERIMENTS_CONFIG } from '../../config/statsig-experiments.config'

export const getStatsigUser = () => {
  const userId = getlbUserId()
  if (!userId) return null
  const user: StatsigUser = { userID: userId, custom: getForcedBucketsForUser() }
  return user
}

const LOCALSTORAGE_FORCEBUCKET_KEY = 'statsigForcedBuckets'
export const getForcedBucketsForUser = () => {
  try {
    if (!isBrowser()) return {}

    // template { experimentName: bucketName }
    const persistedForcedBuckets = JSON.parse(localStorage.getItem(LOCALSTORAGE_FORCEBUCKET_KEY) ?? '{}') as Record<
      string,
      string
    >

    const forcedBuckets: Record<string, string[]> = {}
    const persistedValues: Record<string, string> = {}

    Object.values(STATSIG_EXPERIMENTS_CONFIG).forEach(experimentConfig => {
      // override
      let bucket = getQueryParam(experimentConfig.experimentName)

      if (!bucket) {
        bucket = persistedForcedBuckets[experimentConfig.experimentName]
      }

      if (bucket) {
        // save it as { experimentName: bucketName }
        persistedValues[experimentConfig.experimentName] = bucket

        if (!forcedBuckets[bucket]) forcedBuckets[bucket] = []
        // send it to statsig as { control: [experiment1, experiment2], test: [experiment3] }
        forcedBuckets[bucket]?.push(experimentConfig.experimentName)
      }
    })

    localStorage.setItem(LOCALSTORAGE_FORCEBUCKET_KEY, JSON.stringify(persistedValues))
    return forcedBuckets
  } catch (error) {
    console.error(error)
    return {}
  }
}
